import { Stack, StackProps } from './Stack'

// Atom for creating a vertical stack of elements

type VStackProps = Omit<StackProps, 'direction'>

export function VStack(props: VStackProps) {
  return <Stack {...props} direction="column" />
}
